<form class="p-30 flex flex-col" *ngIf="detailForm" [formGroup]="detailForm">
  <div class="flex flex-col">

    <div class="flex flex-row justify-start items-start auto-flex" *ngIf="isEditing.companyName === false">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Company Name</mat-label>
        <input matInput formControlName="companyName" (click)="editField('companyName')">
      </mat-form-field>
    </div>

    <particle-inplace-input *ngIf="isEditing.companyName === true"
                            [text]="detailForm.value.companyName"
                            placeHolder="Company Name"
                            (valueChanged)="saveFieldData($event, 'companyName')"
                            (cancelled)="resetEditing()">
    </particle-inplace-input>

    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Company ID</mat-label>
        <input matInput formControlName="companyId">
      </mat-form-field>
    </div>

    <div class="flex flex-row justify-start items-start auto-flex" *ngIf="isEditing.description === false">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Description</mat-label>
        <input matInput formControlName="description" (click)="editField('description')">
      </mat-form-field>
    </div>

    <particle-inplace-input *ngIf="isEditing.description === true"
                            [text]="detailForm.value.description"
                            placeHolder="Description"
                            (valueChanged)="saveFieldData($event, 'description')"
                            (cancelled)="resetEditing()">
    </particle-inplace-input>

    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Source</mat-label>
        <input matInput formControlName="source">
      </mat-form-field>
    </div>

    <div class="flex flex-row justify-start items-start auto-flex" *ngIf="isEditing.domain === false">
      <mat-form-field appearance="outline" class="flex-1-1-50">
        <mat-label>Domain</mat-label>
        <input matInput formControlName="domain" (click)="editField('domain')">
      </mat-form-field>
    </div>

    <particle-inplace-input *ngIf="isEditing.domain === true"
                            [text]="detailForm.value.domain"
                            placeHolder="Domain"
                            (valueChanged)="saveFieldData($event, 'domain')"
                            (cancelled)="resetEditing()">
    </particle-inplace-input>

    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-checkbox formControlName="isActive" (change)="updateCompanyData()">Is Active</mat-checkbox>
    </div>

  </div>
</form>
